"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "CompetencyLevelGapSchema", {
    enumerable: true,
    get: function() {
        return CompetencyLevelGapSchema;
    }
});
const _zod = require("zod");
const CompetencyLevelGapSchema = _zod.z.enum([
    "exceeds",
    "meets",
    "below"
]);
